import { RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
    {
        path: "/statistics",
        name: "statistics",
        component: () => import("./pages/Statistics.vue"),
        meta: {
            requiresAuth: true,
            title: "statistics.title",
            breadcrumb: [
                { label: "menu.dashboard", to: "/" },
                { label: "menu.statistics" },
            ],
        },
    },
];

export default routes;
